<template>
<section class="catalog">
  <div class="container">
    <h2>Получите каталог наших проектов</h2>
    <div class="row">
      <div class="col">
        <picture>
          <source srcset="../../public/static/images/sectionCatalog/1.webp">
          <img src="../../public/static/images/sectionCatalog/1.jpg" alt="">
        </picture>
      </div>
      <div class="col" v-if="formState === 0">
        <div class="col-title">
          <h3>Оставьте ваш E-mail, чтобы получить каталог наших проектов</h3>
        </div>
        <div class="col-text">
          <p>Каталог поможет вам выбрать стиль и продумать планировку квартиры</p>
        </div>
        <div class="col-input">
          <div class="input-group">
            <input type="email" id="email1" placeholder="Введите ваш E-mail">
            <label for="email1"></label>
          </div>
          <div class="input-group">
            <input type="checkbox" id="checkbox1">
            <label for="checkbox1">Я согласен на обработку персональных данных</label>
          </div>
          <button class="button" @click="sendForm ()">
            Получить каталог
          </button>
        </div>
      </div>
      <div class="col" v-if="formState === 1">
        <div class="text">
          Спасибо, скоро мы вышлем вам каталог
          <button class="button__transparent button_small" @click="resetForm ()">Закрыть</button>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: 'SectionCatalog',
  data () {
    return {
      formState: 0
    }
  },
  components: {},
  methods: {
    sendForm () {
      this.formState = 1
    },
    resetForm () {
      this.formState = 0
    }
  },
  computed: {},
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.catalog {
  background-color: #eee;
  padding: 45px 0;
  @media (max-width: 575.98px) {
    padding: 20px 0;
  }
  .row {
    display: flex;
    padding-top: 50px;
    flex-wrap: wrap;
    margin: 0 -20px;
    @media (max-width: 1199.98px) {
      flex-wrap: wrap;
    }
    .col {
      box-sizing: border-box;
      overflow: hidden;
      padding: 0 20px;
      &:first-child {
        flex: 0 0 60%;
        max-width: 60%;
        height: 500px;
        @media (max-width: 1199.98px) {
          flex: 1 1 100%;
          max-width: 100%;
          margin-bottom: 20px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
      &:last-child {
        flex: 0 0 40%;
        max-width: 40%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        @media (max-width: 1199.98px) {
          flex: 1 1 100%;
          max-width: 100%;
        }
        .col-title {
          margin-bottom: 40px;
          h3 {
            font-weight: 500;
            font-size: 2.8rem;
          }
        }
        .col-text {
          margin-bottom: 40px;
          p {
            font-weight: 300;
            font-size: 2rem;
            color: #4F4F4F;
          }
        }
        .col-input {
          width: 100%;
          position: relative;
          .input-group {
            margin-bottom: 15px;
            width: 100%;
            position: relative;
          }
          input[type="email"] {
            font-weight: 300;
            font-size: 1.6rem;
            color: #000;
            padding: 20px 30px;
            width: 100%;
            &::placeholder {
              font-weight: 200;
              font-size: 1.6rem;
              color: #4F4F4F;
            }
          }
          input[type="checkbox"] {
            display: none;
            &:checked+label:before {
              background-color: #333333;
            }
            &+label {
              font-weight: 300;
              font-size: 1.4rem;
              color: #333333;
              position: relative;
              padding-left: 22px;
              cursor: pointer;
              &:before {
                transition: .1s linear all;
                width: 15px;
                height: 15px;
                content: '';
                position: absolute;
                left: 0;
                top: -1px;
                border: 1px solid #333333;
              }
            }
          }
          button {
            padding: 20px 30px;
            font-size: 1.6rem;
            width: 100%;
          }
        }
      }
      .text {
        width: 100%;
        height: 100%;
        font-weight: 300;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 2rem;
        button {
          margin-top: 30px;
          width: 100%;
          font-size: 1.6rem;
        }
      }
    }
  }
}
</style>
